import { render, staticRenderFns } from "./FormInputText.vue?vue&type=template&id=632187a8&scoped=true"
import script from "./FormInputText.vue?vue&type=script&lang=js"
export * from "./FormInputText.vue?vue&type=script&lang=js"
import style0 from "./FormInputText.vue?vue&type=style&index=0&id=632187a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632187a8",
  null
  
)

export default component.exports